import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';

// Classes.
import {AthleteGeneralInfoItem} from '../fetching/types/athlete-general-info.item';

// Providers.
import {WABaseService} from '../wa-services/wa-base.service';
import {LoggerService, LogLevel} from '../logger/logger-service';
import {EnvironmentService} from '../wa-services/environment-service';

// Interfaces.
import {AthleteStruct, AthleteContainer, AthleteSearchResult, AthleteDatabaseServiceInterface} from '../interfaces/athlete-database-service.interface'

// Utility.
import {StringTools} from '../util/strings-tools';


export class AthleteLocatorStruct {
  constructor(
    public id: number,
    public athlete: any
  ) {}
}


export abstract class AthletesDatabaseAbstractService extends WABaseService implements AthleteDatabaseServiceInterface {

  protected abstract _db: any;
  protected _dbIsReady: ReplaySubject<boolean>;


  constructor(public logger: LoggerService,
    protected env: EnvironmentService) {
    super(logger, env);
    this.setLogLevel(LogLevel.DEBUG);
    this._dbIsReady = new ReplaySubject<boolean>(1);
    this._dbIsReady.next(false);
  }

  public static prepateStringForSearch(str: string) {
    // Replace mutilple spaces by just one space and transliterate query.
    return StringTools.transliterate(str.replace(/  +/g, ' ')).toUpperCase();
  }

  public dbIsReady(): Observable<boolean> {
    return this._dbIsReady.asObservable();
  }

  protected AthleteGeneralToAthleteContainer(athlete: AthleteGeneralInfoItem): AthleteContainer {
    // Remove ' char (@TODO: To escape them may be is just '', check it!
    let fName = AthletesDatabaseAbstractService.prepateStringForSearch(athlete.fName.replace(/"/g, "'"));
    let gName = AthletesDatabaseAbstractService.prepateStringForSearch(athlete.gName.replace(/"/g, "'"));

    let sCompleteName = athlete.wNameOrd ? fName + ' ' + gName : gName + ' ' + fName;
    let sPartialName = athlete.wNameOrd ? gName : fName;

    let athleteStruct = new AthleteStruct(
      athlete.id,
      athlete.fName,
      athlete.gName,
      athlete.wNameOrd,
      athlete.noc,
      sCompleteName,
      sPartialName
    );

    return new AthleteContainer(athleteStruct.Id + '', null, athleteStruct);
  }


  public abstract initDB(): void;

  public abstract get(athId: number): Observable<AthleteStruct>;

  public abstract storeList(list: AthleteGeneralInfoItem[]): Observable<any>;

  public abstract search(query: string): Observable<AthleteSearchResult>;

}
